import { useStripe, useElements } from '@stripe/react-stripe-js';
import type { Stripe, StripeElements, StripeExpressCheckoutElementConfirmEvent } from '@stripe/stripe-js';

export type OnExpressCheckoutConfirm = (
  stripe: Stripe,
  elements: StripeElements,
  expressPaymentType: string,
  onPaymentFailed: () => void,
) => Promise<void>;

export const useExpressCheckout = (onExpressCheckoutConfirm: OnExpressCheckoutConfirm) => {
  const stripe = useStripe();
  const elements = useElements();

  const onConfirm = async (event: StripeExpressCheckoutElementConfirmEvent) => {
    let isPaymentFailedReported = false;

    // Stripe allows a single paymentFailed() per confirm event and none after the payment has been submitted
    const reportPaymentFailed = () => {
      if (isPaymentFailedReported) return;
      isPaymentFailedReported = true;

      try {
        event.paymentFailed({ reason: 'fail' });
      } catch (error) {
        console.warn('[useExpressCheckout] paymentFailed rejected by Stripe', error);
      }
    };

    if (!stripe || !elements) {
      reportPaymentFailed();
      return;
    }

    try {
      await onExpressCheckoutConfirm(stripe, elements, event.expressPaymentType, reportPaymentFailed);
    } catch (error) {
      console.error('[useExpressCheckout] onExpressCheckoutConfirm failed', error);
      reportPaymentFailed();
    }
  };

  return { onConfirm };
};
